import { ACTION_IDS } from "../actionIds";

/**
 * Default sticky header actions: all actions with visibility from context.
 * Order: multistore, calculator, calculations, logs, reports, dispensing, settings, users, logout.
 */
export function getHeaderActions(context) {
  const {
    isServicePartnerCustomer,
    isMultiLicense,
    showCalculator,
    showCalculations,
    showLogs,
    showReports,
    showDispensingOrders,
    dispensingOrdersUrl,
    showSettings,
    isLoggedIn,
    dsokType,
    finalCustomer,
  } = context;

  const showUsers =
    !isServicePartnerCustomer && isLoggedIn && !!dsokType;
  const showDispensing =
    !isServicePartnerCustomer &&
    showDispensingOrders &&
    !!dispensingOrdersUrl;

  return [
    {
      id: ACTION_IDS.MULTISTORE,
      visible: !isServicePartnerCustomer && isMultiLicense,
      tooltipKey: "multistore.iconTooltip",
      tooltipDefault: "Switch company",
      ariaLabelKey: "multistore.iconTooltip",
      ariaLabelDefault: "Switch company",
      iconId: "multistore",
    },
    {
      id: ACTION_IDS.CALCULATOR,
      visible: !isServicePartnerCustomer && showCalculator,
      tooltip: "Kalkulačka cien",
      ariaLabel: "Kalkulačka cien",
      iconId: "calculator",
    },
    {
      id: ACTION_IDS.CALCULATIONS,
      visible: !isServicePartnerCustomer && showCalculations,
      tooltip: "Konfigurátor produktov",
      ariaLabel: "Kalkulačka cien",
      iconId: "calculations",
    },
    {
      id: ACTION_IDS.LOGS,
      visible: !isServicePartnerCustomer && showLogs,
      tooltip: "Logs",
      ariaLabel: "Logs",
      iconId: "logs",
    },
    {
      id: ACTION_IDS.REPORTS,
      visible: !isServicePartnerCustomer && showReports,
      tooltipKey: "sidebar.menuItem.dsokReports",
      ariaLabelKey: "sidebar.menuItem.dsokReports",
      iconId: "reports",
    },
    {
      id: ACTION_IDS.DISPENSING,
      visible: showDispensing,
      tooltipKey: "sidebar.menuItem.dsokDispensingOrders",
      ariaLabelKey: "sidebar.menuItem.dsokDispensingOrders",
      iconId: "dispensing",
    },
    {
      id: ACTION_IDS.SETTINGS,
      visible: !isServicePartnerCustomer && showSettings,
      tooltipKey: "sidebar.menuItem.dsokSettings",
      ariaLabelKey: "sidebar.menuItem.dsokSettings",
      iconId: "settings",
    },
    {
      id: ACTION_IDS.USERS,
      visible: showUsers,
      tooltipKey: "stickyMenu.users",
      tooltipDefault: "Users",
      ariaLabelKey: "stickyMenu.users",
      ariaLabelDefault: "Users",
      iconId: "users",
    },
    {
      id: ACTION_IDS.LOGOUT,
      visible: isLoggedIn,
      tooltip: "Logout",
      ariaLabel: "Logout",
      iconId: "logout",
    },
  ];
}
